import { useEffect, useState } from "react";
import { Input, Button, DatePicker, message } from "antd";
import useRoleAccess from "@/hooks/useRoleAccess";
import dayjs from "dayjs";
import axios from "axios";

export default function DetailKendaraan({
  data,
  application_id,
  dealerId,
  harga,
  setHarga,
  uangMukaAmount,
  setUangMukaAmount,
  getData,
}) {
  const API_BASE_URL2 = import.meta.env.VITE_BASE_URL2;
  const { isViewer } = useRoleAccess();

  // console.log("application_id ==>", application_id);
  const kendaraanItems = data?.[0]?.data?.kendaraan || [];

  const [isEdit, setIsEdit] = useState(false);
  const [editItems, setEditItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!kendaraanItems.length) return;

    setEditItems(kendaraanItems);

    const hargaFromData = kendaraanItems.find(
      (i) => i.label === "Harga Kendaraan",
    )?.value;

    const uangMukaFromData = kendaraanItems.find(
      (i) => i.label === "Uang Muka",
    )?.value;

    if (hargaFromData && !harga) setHarga(hargaFromData);
    if (uangMukaFromData && !uangMukaAmount)
      setUangMukaAmount(uangMukaFromData);
  }, [kendaraanItems]);

  const formatRupiah = (value) => {
    if (!value) return "";
    const number = value.toString().replace(/\D/g, "");
    return new Intl.NumberFormat("id-ID").format(number);
  };

  const parseRupiah = (value) => {
    if (!value) return "0"; // handle null, undefined, ""
    return value.toString().replace(/\D/g, "");
  };

  const fieldMap = {
    "Kondisi kendaraan": "kondisikendaraan",
    "Merk Kendaraan": "merkkendaraan",
    "Nama Dealer": "namadealer",
    "Tipe Kendaraan": "typekendaraan",
    "Tahun Kendaraan": "tahunkendaraan",
    "No Polisi Kendaraan": "nopolisikendaraan",
    "Harga Kendaraan": "hargakendaraan",
    "Uang Muka": "uangmuka",
    "Pokok Hutang": "pokokhutang",
  };

  const handleChange = (idx, value) => {
    const updated = [...editItems];
    updated[idx] = { ...updated[idx], value };
    setEditItems(updated);
  };

  const mapToPayload = (items) => {
    return items.reduce((acc, item) => {
      const key = fieldMap[item.label];
      if (!key) return acc;

      let val = item.value;

      // khusus rupiah → angka murni
      if (
        item.label === "Harga Kendaraan" ||
        item.label === "Uang Muka" ||
        item.label === "Pokok Hutang"
      ) {
        val = parseRupiah(item.value);
      }

      acc[key] = val;

      acc["application_id"] = application_id;

      return acc;
    }, {});
  };

  const handleSave = async () => {
    const payload = mapToPayload(editItems);

    console.log("payloadd ==>", payload);

    try {
      setLoading(true);
      await axios.put(
        `${API_BASE_URL2}/api/updatedealer/${application_id}`,
        payload,
      );
      // await axios.post(`${API_BASE}/api/user/users`, payload);

      message.success("Data kendaraan berhasil diupdate");
      setIsEdit(false);

      await getData();
    } catch (err) {
      console.error(err);
      message.error("Gagal update data kendaraan");
    } finally {
      setLoading(false);
    }
  };

  if (!kendaraanItems.length) {
    return <p className="text-gray-500">Tidak ada data kendaraan.</p>;
  }

  return (
    <div>
      {/* BUTTON */}
      <div className="flex justify-end mb-3 gap-2">
        {!isEdit ? (
          <Button
            type="primary"
            onClick={() => setIsEdit(true)}
            disabled={loading || isViewer}
          >
            Edit
          </Button>
        ) : (
          <>
            <Button
              type="primary"
              loading={loading}
              onClick={handleSave}
              disabled={loading || isViewer}
            >
              Simpan
            </Button>

            <Button
              onClick={() => {
                setEditItems(kendaraanItems);
                setIsEdit(false);
              }}
              disabled={loading}
            >
              Batal
            </Button>
          </>
        )}
      </div>

      {/* CONTENT */}
      <div className="grid grid-cols-2 gap-4">
        {(isEdit ? editItems : kendaraanItems).map((item, idx) => {
          const isPriceField =
            item.label === "Harga Kendaraan" ||
            item.label === "Uang Muka" ||
            item.label === "Pokok Hutang";

          const isYearField = item.label === "Tahun Kendaraan";

          return (
            <div key={idx} className="flex items-center gap-2">
              <div className="w-1/2 text-sm text-gray-600">{item.label}</div>

              <div className="w-1/2">
                {isEdit ? (
                  isYearField ? (
                    <DatePicker
                      picker="year"
                      value={item.value ? dayjs(item.value, "YYYY") : null}
                      onChange={(date) =>
                        handleChange(idx, date ? date.format("YYYY") : "")
                      }
                      className="w-full"
                      disabled={loading} // ✅ disable saat loading
                    />
                  ) : isPriceField ? (
                    <Input
                      value={formatRupiah(item.value)}
                      onChange={(e) =>
                        handleChange(idx, formatRupiah(e.target.value))
                      }
                      prefix="Rp"
                      disabled={loading} // ✅ disable saat loading
                    />
                  ) : (
                    <Input
                      value={item.value}
                      onChange={(e) => handleChange(idx, e.target.value)}
                      disabled={loading} // ✅ disable saat loading
                    />
                  )
                ) : (
                  <span className="text-sm font-semibold text-gray-800">
                    {isPriceField
                      ? `Rp ${formatRupiah(item.value)}`
                      : item.value || "-"}
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
